/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramUsersModeratorControllerFindManyQueryResponse,
  TelegramUsersModeratorControllerFindManyQueryParams,
  TelegramUsersModeratorControllerFindMany401,
} from '../types/TelegramUsersModeratorControllerFindMany.ts';

function getTelegramUsersModeratorFindManyUrl() {
  const res = { method: 'GET', url: `/api/moderator/telegram/users` as const };
  return res;
}

/**
 * {@link /api/moderator/telegram/users}
 */
export async function telegramUsersModeratorFindMany(
  params?: TelegramUsersModeratorControllerFindManyQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramUsersModeratorControllerFindManyQueryResponse,
    ResponseErrorConfig<TelegramUsersModeratorControllerFindMany401>,
    unknown
  >({ method: 'GET', url: getTelegramUsersModeratorFindManyUrl().url.toString(), params, ...requestConfig });
  return res.data;
}
